export const menuLinks = {
  apiGuides: 'https://docs.goshippo.com/',
  apiReference: 'https://docs.goshippo.com/shippoapi/public-api/',
  clientLib: 'https://docs.goshippo.com/docs/guides_general/clientlibraries/',
  contactSales: 'https://goshippo.com/products/api#contact-an-expert',
  customerSupport: 'https://support.goshippo.com/',
  postmanCollection:
    'https://god.gw.postman.com/run-collection/22332580-0c7ca172-af19-43f6-86f9-520fec94dd56',
};
